module.exports = __webpack_public_path__ + "img/vuereact.b6c5f62e.jpg";